(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["webjoias-buy-with"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.wj-combo').forEach(root=>{const boxes=[...root.querySelectorAll('[data-combo-variant]')], total=root.querySelector('[data-combo-total]'),count=root.querySelector('[data-combo-count]'),inst=root.querySelector('[data-combo-installments]'),btn=root.querySelector('[data-combo-add]'),error=root.querySelector('[data-combo-error]');const money=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'});let price=0;function update(){price=0;let n=0;boxes.forEach(b=>{b.closest('.wj-combo-card')?.classList.toggle('selected',b.checked);if(b.checked){price+=Number(b.dataset.comboPrice)||0;n++}});total.textContent=money.format(price/100);count.textContent=n;let p=Math.max(1,Math.min(10,Math.floor(price/5000)||1));inst.textContent='Até '+p+'x de '+money.format(price/p/100)+' sem juros*';btn.disabled=n===0}function sync(){let b=boxes.find(x=>x.dataset.main);let sel=document.querySelector('.sp-form-compra select[name="id"]');if(sel?.selectedOptions[0]){b.value=sel.value;let pr=sel.selectedOptions[0].dataset.priceCents;if(pr)b.dataset.comboPrice=pr}else{let inp=document.querySelector('.sp-form-compra input[name="id"]');if(inp)b.value=inp.value}}document.addEventListener('change',()=>{sync();update()});btn.addEventListener('click',async()=>{sync();btn.disabled=true;error.textContent='';let items=boxes.filter(b=>b.checked&&b.value).map(b=>({id:Number(b.value),quantity:1}));try{let response=await fetch(root.dataset.addUrl+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});if(!response.ok)throw Error('Confira as opções de tamanho e disponibilidade');location.assign(root.dataset.cartUrl)}catch(e){error.textContent=e.message;update()}});sync();update()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["webjoias-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.webjoias-carousel').forEach((carousel) => {
      const slides = [...carousel.querySelectorAll('.webjoias-carousel__slide')];
      const dots = [...carousel.querySelectorAll('.webjoias-carousel__dot')];
      const prev = carousel.querySelector('.webjoias-carousel__arrow--prev');
      const next = carousel.querySelector('.webjoias-carousel__arrow--next');

      if (slides.length < 2) return;

      let current = 0;
      let timer;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        timer = window.setInterval(() => show(current + 1), 5500);
      };

      prev?.addEventListener('click', () => { show(current - 1); start(); });
      next?.addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => {
        show(Number(dot.dataset.slideTo));
        start();
      }));

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);

      start();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
